var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0H7.5C3.35786 0 0 3.35786 0 7.5V42.5C0 46.6421 3.35786 50 7.5 50H42.5C46.6421 50 50 46.6421 50 42.5V7.5C50 3.35786 46.6421 0 42.5 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 16.8555H39.3518C39.9688 16.8555 40.4692 17.3559 40.4692 17.973V32.4965C40.4692 33.1135 39.9688 33.614 39.3518 33.614H28.2812V16.8555Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9457 20.6328H28.2812V32.4719H38.9457V20.6328Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5203 40.47L10 37.0421V13.4279L27.5203 10V40.47Z",
    fill: "#1976D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5715 19.5215C16.1522 19.5215 14.1914 22.0794 14.1914 25.2346C14.1914 28.3898 16.1522 30.9477 18.5715 30.9477C20.9908 30.9477 22.9515 28.3898 22.9515 25.2346C22.9515 22.0794 20.9908 19.5215 18.5715 19.5215ZM18.381 28.6625C17.1188 28.6625 16.0958 27.1276 16.0958 25.2346C16.0958 23.3417 17.1188 21.8067 18.381 21.8067C19.6433 21.8067 20.6663 23.3417 20.6663 25.2346C20.6663 27.1276 19.6433 28.6625 18.381 28.6625Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3731 29.6055H28.3164V31.8145H30.3731V29.6055Z",
    fill: "#1976D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9669 29.6055H30.9102V31.8145H32.9669V29.6055Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5567 29.6055H33.5V31.8145H35.5567V29.6055Z",
    fill: "#1976D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3731 26.8799H28.3164V29.089H30.3731V26.8799Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9669 26.8799H30.9102V29.089H32.9669V26.8799Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5567 26.8799H33.5V29.089H35.5567V26.8799Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1466 26.8799H36.0898V29.089H38.1466V26.8799Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3731 24.249H28.3164V26.4581H30.3731V24.249Z",
    fill: "#1976D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9669 24.249H30.9102V26.4581H32.9669V24.249Z",
    fill: "#1976D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5567 24.249H33.5V26.4581H35.5567V24.249Z",
    fill: "#1976D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1466 24.249H36.0898V26.4581H38.1466V24.249Z",
    fill: "#1976D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9669 21.5117H30.9102V23.7208H32.9669V21.5117Z",
    fill: "#1976D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5567 21.5117H33.5V23.7208H35.5567V21.5117Z",
    fill: "#1976D2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1466 21.5117H36.0898V23.7208H38.1466V21.5117Z",
    fill: "#1976D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.4860a51b5fb41492999652411b261f0f.svg";
export { ForwardRef as ReactComponent };